// `video.talking_head`: one actor of live's Talking Head speaking (#222).
// Live's video list; the Talking Head form starts these, not a Studio draft.
import { VideoTalkingHeadQuote, VideoTalkingHeadRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.talking_head"> = {
  type: "video.talking_head",
  label: "Simple Talking Head",
  source: "form",
  pair: "video.talking_head",
  fields: () => ({}),
  request: VideoTalkingHeadRequest,
  quote: VideoTalkingHeadQuote,
};
